import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  FETCH_ALL_FILTERS_ASYNC,
  MAILBOX_ANOMALY_REQUEST_ASYNC,
  MITIGATION_REQUEST_ASYNC,
  MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC,
  RESET_FILTERS,
  TOP_PROFILES_REQUEST_ASYNC,
} from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export const fetchTopProfiles = () => ({
  type: TOP_PROFILES_REQUEST_ASYNC.INITIATE,
})
export const fetchTopProfilesSuccess = (data) => ({
  type: TOP_PROFILES_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTopProfilesError = (error) => ({
  type: TOP_PROFILES_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchTopProfilesCancel = () => ({
  type: TOP_PROFILES_REQUEST_ASYNC.CANCEL,
})

export const fetchMitigationData = () => ({
  type: MITIGATION_REQUEST_ASYNC.INITIATE,
})
export const fetchMitigationDataSuccess = (data) => ({
  type: MITIGATION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchMitigationDataError = (error) => ({
  type: MITIGATION_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchMitigationDataCancel = () => ({
  type: MITIGATION_REQUEST_ASYNC.CANCEL,
})

export const fetchMailboxAnomaly = () => ({
  type: MAILBOX_ANOMALY_REQUEST_ASYNC.INITIATE,
})
export const fetchMailboxAnomalySuccess = (data) => ({
  type: MAILBOX_ANOMALY_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchMailboxAnomalyError = (error) => ({
  type: MAILBOX_ANOMALY_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchMailboxAnomalyCancel = () => ({
  type: MAILBOX_ANOMALY_REQUEST_ASYNC.CANCEL,
})

export const fetchAllFilters = () => ({
  type: FETCH_ALL_FILTERS_ASYNC.INITIATE,
})
export const fetchAllFiltersCancel = () => ({
  type: FETCH_ALL_FILTERS_ASYNC.CANCEL,
})
export const fetchAllFiltersSuccess = (data) => ({
  type: FETCH_ALL_FILTERS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAllFiltersError = (error) => ({
  type: FETCH_ALL_FILTERS_ASYNC.ERROR,
  error,
})

const dateFilterChange = (value) => ({
  type: DATE_FILTER_CHANGE,
  payload: { value },
})

export const fetchMostTargetedEmployees = () => ({
  type: MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.INITIATE,
})
export const fetchMostTargetedEmployeesCancel = () => ({
  type: MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.CANCEL,
})
export const fetchMostTargetedEmployeesSuccess = (data) => ({
  type: MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchMostTargetedEmployeesError = (error) => ({
  type: MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  // to props
  fetchData,
  fetchDataCancel,
  fetchTopProfiles,
  fetchTopProfilesCancel,
  fetchMitigationData,
  fetchMitigationDataCancel,
  fetchMailboxAnomaly,
  fetchMailboxAnomalyCancel,
  dateFilterChange,
  fetchAllFilters,
  fetchAllFiltersCancel,
  fetchMostTargetedEmployees,
  fetchMostTargetedEmployeesCancel,
}
